import React from 'react'
import ScheduleTab from './ScheduleTab'

class ScheduleTabHeader extends React.Component {
  constructor (props) {
    super(props)
    if (props.viewTab == 'calendar') {
      this.state = {
        calendar_status: 'active',
        timeline_status: 'inactive',
        category_status: 'inactive'
      }
    } else if (props.viewTab == 'timeline') {
        this.state = {
          calendar_status: 'inactive',
          timeline_status: 'active',
          category_status: 'inactive'
        }
    } else {
      this.state = {
        calendar_status: 'inactive',
        timeline_status: 'inactive',
        category_status: 'active'
      }
    }
  }

  changeTab (tab) {
    const timelineMapper = {
      timeline: {
        calendar_status: 'inactive',
        timeline_status: 'active',
        category_status: 'inactive'
      },
      calendar: {
        calendar_status: 'active',
        timeline_status: 'inactive',
        category_status: 'inactive'
      },
      category: {
        calendar_status: 'inactive',
        timeline_status: 'inactive',
        category_status: 'active'
      },
    }
    this.setState(timelineMapper[tab])

    this.props.handleTabChange(tab)
  }

  render () {
    return (
      <table className='schedule-sidebar-header'>
        <thead></thead>
        <tbody>
          <tr>
            <ScheduleTab
              classname={`${this.state.calendar_status} leftmost-cell`}
              tab='calendar'
              icon='fa fa-th-large'
              text='Calendar'
              handleTabChange={this.changeTab.bind(this)}
            />
            <ScheduleTab
              classname={`${this.state.timeline_status}`}
              tab='timeline'
              icon='fa fa-tasks'
              text='Timeline'
              handleTabChange={this.changeTab.bind(this)}
            />
            <ScheduleTab
              classname={`${this.state.category_status} rightmost-cell`}
              tab='category'
              icon='fa fa-th-list'
              text='CheckList'
              handleTabChange={this.changeTab.bind(this)}
            />
          </tr>
        </tbody>
      </table>
    )
  }
}

export default ScheduleTabHeader;